module.exports = __webpack_public_path__ + "static/img/header-3.f75ff17.png";